import { Vessel } from "../../documents/models/documents.models";
import { logE, log } from "../../shared/services/debug-logger";
import { fetchDataWithParams, postData } from "../../shared/services/service";
import { VesselTrueOwner } from "../models/vessel-details.models";
import { Dispatch, SetStateAction } from "react";

export async function getPortConsumption(imoNumber: string | undefined, vesselCode: string | undefined) {
  const requestData = {
    imo_no: imoNumber,
    vessel_code: vesselCode,
  };
  const filteredRequestData = Object.fromEntries(
    Object.entries(requestData).filter(([_, value]) => value !== undefined && value !== null),
  ) as Record<string, string>;
  const queryParams = new URLSearchParams(filteredRequestData).toString();
  const result = await fetchDataWithParams(`portConsumptionDetails?${queryParams}`);

  // In case BE has them sorted in the wrong order
  const idle = result.data.find((consumption: any) => consumption.TYPE === "IDLE");
  const working = result.data.find((consumption: any) => consumption.TYPE === "WORKING");
  return { working, idle };
}

export async function getEcoSpeedConsumption(
  imoNumber: string | undefined,
  vesselCode: string | undefined,
  vesselName: string | undefined,
) {
  const requestData = {
    imo_number: imoNumber,
    vessel_code: vesselCode,
    vessel_name: vesselName,
  };
  const filteredRequestData = Object.fromEntries(
    Object.entries(requestData).filter(([_, value]) => value !== undefined && value !== null),
  ) as Record<string, string>;
  const queryParams = new URLSearchParams(filteredRequestData).toString();
  const result = await fetchDataWithParams(`eco_speed_consumption?${queryParams}`);
  const ecoSpeed = result.data;
  return ecoSpeed;
}

export async function getCpSpeedConsumption(
  imoNumber: string | undefined,
  vesselCode: string | undefined,
  vesselName: string | undefined,
) {
  const requestData = {
    imo_number: imoNumber,
    vessel_code: vesselCode,
    vessel_name: vesselName,
  };
  const filteredRequestData = Object.fromEntries(
    Object.entries(requestData).filter(([_, value]) => value !== undefined && value !== null),
  ) as Record<string, string>;
  const queryParams = new URLSearchParams(filteredRequestData).toString();
  const result = await fetchDataWithParams(`cp_speed_consumption?${queryParams}`);
  const cpSpeed = result.data;
  return cpSpeed;
}

export async function getInputSpeedConsumption(
  imoNumber: string | undefined,
  vesselCode: string | undefined,
  vesselName: string | undefined,
) {
  const requestData = {
    imo_number: imoNumber,
    vessel_code: vesselCode,
    vessel_name: vesselName,
  };
  const filteredRequestData = Object.fromEntries(
    Object.entries(requestData).filter(([_, value]) => value !== undefined && value !== null),
  ) as Record<string, string>;
  const queryParams = new URLSearchParams(filteredRequestData).toString();
  const result = await fetchDataWithParams(`input_speed_consumption?${queryParams}`);
  const inputSpeed = result.data;
  return inputSpeed;
}

export const togglePerfTableCol = (setVisCols: Dispatch<SetStateAction<string[]>>) => (colName: string) => {
  setVisCols((prevCols: string[]) => {
    let newCols = [...prevCols];
    if (newCols.includes(colName)) {
      newCols = newCols.filter((col) => col !== colName);
    } else {
      newCols.push(colName);
    }
    return newCols;
  });
};

export async function getVesselTrueOwner(vessel: Vessel | undefined): Promise<VesselTrueOwner | undefined> {
  if (!vessel) {
    return;
  }

  const requestData = {
    vesselName: vessel?.name,
    vesselCode: vessel?.code,
    imoNumber: vessel?.imoNumber,
  };

  const filteredRequestData = Object.fromEntries(
    Object.entries(requestData).filter(([_, value]) => value !== undefined && value !== null),
  ) as Record<string, string>;

  const queryParams = new URLSearchParams(filteredRequestData).toString();
  const result = await fetchDataWithParams(`vessel-true-owner?${queryParams}`);
  const trueOwner = result.data[0];
  log("SERV - getVesselTrueOwner - response", { found: Boolean(trueOwner) });

  return trueOwner;
}

export async function getUniqueTrueOwners(): Promise<string[]> {
  try {
    const resp = await fetchDataWithParams(`vessel-true-owner/unique`);
    return resp.data;
  } catch (error) {
    logE(new Error("SERV - getUniqueTrueOwners - failed"));
    throw error;
  }
}

export async function updateVesselTrueOwner(vessel: Vessel, trueOwner: string, submittedBy: string) {
  try {
    log("SERV - updateVesselTrueOwner", { vesselCode: vessel.code });
    await postData(`vessel-true-owner`, {
      vesselName: vessel.name,
      vesselCode: vessel.code,
      imoNumber: vessel.imoNumber,
      trueOwner,
      submittedBy,
    });
  } catch (error) {
    logE(new Error("SERV - updateVesselTrueOwner - failed"));
    throw error;
  }
}
